import moment from 'moment';

export const getDefaultStartDate = () => moment(new Date(0));

export const getDefaultEndDate = () => moment(new Date(8640000000000000));

export const getDateOrDefaultStartDate = (dateString) => (dateString ? moment(dateString) : getDefaultStartDate());

export const getDateOrDefaultEndDate = (dateString) => (dateString ? moment(dateString) : getDefaultEndDate());
